import React, {useState, useEffect, useRef} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import _FM_GuestListComponent from "../components/_FM_guest/_FM_GuestListComponent";
import _FM_GuestFormComponent from "../components/_FM_guest/_FM_GuestFormComponent";
import _FM_GuestShowComponent from "../components/_FM_guest/_FM_GuestShowComponent";
import HelpComponent from "../components/HelpComponent";

const _FM_GuestPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action} = useParams();

  useEffect(() => {
    document.title = t('guests') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/guest')
  }, []);

  useEffect(() => {
    if(!action) {
      window.App.setState({
        sidebarGuestForm: false,
        sidebarGuestShow: false,
      })
    }
    // if(action === 'create'){
    //   window.App.setState({
    //     sidebarGuestForm: true,
    //   })
    // }
    if(id && action === 'read'){
      window.App.setState({
        sidebarGuestShow: true,
      })
    }
    if(id && action === 'update'){
      window.App.setState({
        sidebarGuestForm: true,
      })
    }
  }, [id, action]);

  return (
    <div className="_FM_GuestPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/guest"}/>
      <Panel>
        <_FM_GuestListComponent />
      </Panel>
      <Sidebar position="right" visible={window.App.state.sidebarGuestForm} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/guest');
               }}>
        <_FM_GuestFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={window.App.state.sidebarGuestShow} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate('/guest');
               }}>
        <_FM_GuestShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(_FM_GuestPage);
